/*! DataTables Tailwind CSS integration
 */

(function (factory) {
    if (typeof define === "function" && define.amd) {
        // AMD
        define(["jquery", "datatables.net"], function ($) {
            return factory($, window, document);
        });
    } else {
        // Browser
        factory(jQuery, window, document);
    }
})(function ($, window, document) {
    "use strict";
    var DataTable = $.fn.dataTable;

    /*
     * This is a tech preview of Tailwind CSS integration with DataTables.
     */

    // Set the defaults for DataTables initialisation
    $.extend(true, DataTable.defaults, {
        renderer: "tailwindcss",
    });

    // Default class modification
    $.extend(true, DataTable.ext.classes, {
        container: "dt-container dt-tailwindcss",
        search: {
            input: "border placeholder-gray-500 ml-2 px-3 py-2 rounded-lg border-gray-200 focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50",
        },
        length: {
            select: "border px-8 py-2 rounded-lg border-gray-200 focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50",
        },
        processing: {
            container: "dt-processing",
        },
        paging: {
            active: "font-semibold bg-gray-100 text-blue-600",
            notActive: "bg-white",
            button: "relative inline-flex justify-center items-center px-3 py-1.5 text-xs sm:text-sm border -mr-px hover:z-10 focus:z-10 active:z-10 border-gray-200 active:border-gray-200 active:shadow-none",
            first: "rounded-l-md",
            last: "rounded-r-md",
            enabled:
                "text-gray-800 hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm focus:ring focus:ring-gray-300 focus:ring-opacity-25",
            notEnabled: "text-gray-400 cursor-not-allowed pointer-events-none",
        },
        table: "dataTable min-w-full text-xs text-wrap align-middle whitespace-nowrap table table-zebra table-xs",
        thead: {
            row: "border-b border-gray-100",
            cell: "px-2 py-3 text-gray-900 bg-gray-100/75 font-semibold text-left text-wrap",
        },
        tbody: {
            row: "even:bg-gray-50 hover",
            cell: "p-2",
        },
        tfoot: {
            row: "even:bg-gray-50",
            cell: "p-2 text-left",
        },
    });

    DataTable.ext.renderer.pagingButton.tailwindcss = function (
        settings,
        buttonType,
        content,
        active,
        disabled
    ) {
        var classes = settings.oClasses.paging;

        if (buttonType === "ellipsis") {
            var span = $("<span>", {
                class: classes.button + " " + classes.notActive + " " + classes.notEnabled + " select-none",
            }).html(content);

            return {
                display: span,
                clicker: span,
            };
        }

        var btnClasses = [classes.button];

        btnClasses.push(active ? classes.active : classes.notActive);
        btnClasses.push(disabled ? classes.notEnabled : classes.enabled);

        var a = $("<a>", {
            href: disabled ? null : "#",
            class: btnClasses.join(" "),
        }).html(content);

        return {
            display: a,
            clicker: a,
        };
    };

    DataTable.ext.renderer.pagingContainer.tailwindcss = function (
        settings,
        buttonEls
    ) {
        var classes = settings.oClasses.paging;

        if (buttonEls.length > 0) {
            buttonEls[0].addClass(classes.first);
            buttonEls[buttonEls.length - 1].addClass(classes.last);
        }

        return $("<ul/>").addClass("pagination inline-flex flex-nowrap items-center").append(buttonEls);
    };

    DataTable.ext.renderer.layout.tailwindcss = function (
        settings,
        container,
        items
    ) {
        var row = $("<div/>", {
            class: items.full
                ? "flex flex-col gap-4 mb-4"
                : "flex flex-col md:flex-row justify-between items-center gap-4 mb-4",
        }).appendTo(container);

        $.each(items, function (key, val) {
            var klass;

            // Apply start / end (left / right when ltr) margins
            if (val.table) {
                klass = "w-full";
            } else if (key === "start") {
                klass = "w-full md:w-auto flex justify-start items-center";
            } else if (key === "end") {
                klass = "w-full md:w-auto flex justify-end items-center";
            } else {
                klass = "w-full md:w-auto flex justify-center items-center";
            }

            $("<div/>", {
                id: val.id || null,
                class: klass + " " + (val.className || ""),
            })
                .append(val.contents)
                .appendTo(row);
        });
    };

    return DataTable;
});
